<template>
  <vue-ueditor-wrap
    v-model="dataModel"
    @ready="ready"
    :config="ueditorConfig"
    :destroy="true"
    :key="ueditorKey"
  ></vue-ueditor-wrap>
</template>

<script>
import { generateUUID } from '../../util/index.js'
import globalBus from '../../util/globalBus'
import VueUeditorWrap from './vue-ueditor-wrap'
export default {
  components: {
    VueUeditorWrap,
  },
  name: 'fm-ueditor',
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: 'editor-' + generateUUID(),
      dataModel: this.value,
      ueditorKey: 1,
      ueditorConfig: {
        initialFrameHeight: 500,
        UEDITOR_HOME_URL: 'UEditor/',
        serverUrl: '',
        iframeCssUrl: 'UEditor/themes/iframe.css',
        headers: {},
      },
    }
  },
  created() {
    this.ueditorConfig.serverUrl =
      localStorage.getItem('baseURL') + '/uu/ueditor'
    const token = localStorage.getItem('Admin-Token')
    this.$set(this.ueditorConfig.headers, 'X-Id-Token', token)
    this.$set(this.ueditorConfig.headers, 'Authorization', 'Bearer ' + token)
    const visitor = sessionStorage.getItem('visitor') || '0'
    this.$set(this.ueditorConfig.headers, 'visitor', visitor)
  },
  mounted() {
    // 遍历所有的token 替换为新的token(防止token过期失效)
    // const token = localStorage.getItem('Admin-Token')
    // const data = this.value.replace(/(?<=token=).*?(?=")/g, token)
    // this.dataModel = data
  },
  methods: {
    ready(ue) {
      globalBus.$on('changeUETheme', theme => {
        switch (theme) {
          case '1':
            this.ueditorConfig.iframeCssUrl =
              'UEditor/themes/iframe-special.css'
            break
          case '2':
          default:
            this.ueditorConfig.iframeCssUrl = 'UEditor/themes/iframe.css'
        }
        this.ueditorKey++
      })
      if (this.disabled) {
        ue.setDisabled()
      } else {
        ue.setEnabled()
      }
      this.$watch('disabled', newVal => {
        if (newVal) {
          ue.setDisabled()
        } else {
          ue.setEnabled()
        }
      })
    },
  },
  watch: {
    dataModel(val) {
      this.$emit('input', val)
      this.$emit('change')
    },
    value(val) {
      this.dataModel = val
    },
  },
}
</script>
